export const extractDomain = (url: string): string => {
	try {
		return new URL(url).hostname.replace(/^www\./, '');
	} catch {
		return '';
	}
};

export const getFaviconUrl = (domain: string, size: number = 32): string =>
	`https://www.google.com/s2/favicons?domain=${domain}&sz=${size}`;
